import * as React from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton
} from '@mui/material';
import { ct } from '../../../constant-Utils';
import { Icon, IconCloseCircle } from '../../../../base/icons';
import { styled } from '@material-ui/core';


export default function ConfirmationAlert(props) {
    const [open, setOpen] = React.useState(false);
    const [isSubmitClicked, setIsSubmitClicked] = React.useState(false);

    const { title, handleConfirmAction, showCloseIcon = false, showFooter = true } = props;

    const handleClose = (type) => {
        setOpen(false);
        setIsSubmitClicked(type);
        handleConfirmAction(type)
    };

    React.useEffect(() => {
        setOpen(true);
    }, [])

    return (
        <div>
            <Div
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                id='confirmation-mui-dialog'
            >
                {showCloseIcon ? (
                    <DialogTitle id="alert-dialog-title">
                        <IconButton
                            aria-label="close"
                            onClick={handleClose}
                            sx={{
                                position: 'absolute',
                                right: 8,
                                top: 8,
                                color: (theme) => theme.palette.grey[500],
                            }}
                        >
                            <Icon src={IconCloseCircle} color='#000' />
                        </IconButton>
                    </DialogTitle>
                ) : null}
                <DialogTitle id="alert-dialog-title">
                    {title}
                </DialogTitle>
                <DialogContent>
                    {props?.children}
                </DialogContent>
                {showFooter && <DialogActions>
                    <Button
                        id='cancel-btn-confirmation-modal'
                        onClick={() => handleClose(false)}
                        variant="outlined"
                        sx={{
                            fontSize: 14,
                            borderColor: "var(--theme-primary-color)",
                            color: "var(--theme-primary-color)",
                            "&:hover": {
                                color: "var(--theme-primary-color)",
                                borderColor: "var(--theme-primary-color)",
                            }
                        }}
                    >{ct("Translate.buttonTitle.noSmall")}</Button>
                    <Button
                        id='success-btn-confirmation-modal'
                        onClick={() => handleClose(true)}
                        // autoFocus
                        variant="contained"
                        disabled={isSubmitClicked}
                        color="error"
                        sx={{
                            fontSize: 14
                        }}
                    >
                        {ct("Translate.buttonTitle.yesSmall")}
                    </Button>
                </DialogActions>}
            </Div>
        </div>
    );
}

const Div = styled(Dialog)(({ theme }) => ({
    '& .MuiPaper-root': {
      minWidth: 320
    } 
  }));